export default __webpack_public_path__ + "static/media/check.ee38324a.svg";